module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.options), function(option) {
    return _c('li', [_c('label', {
      on: {
        "click": function($event) {
          return _vm.check(option.code)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "name": _vm.name
      },
      domProps: {
        "value": option.code,
        "checked": _vm.selected === option.code
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "radio-button"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.label))])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c219dfa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/RadioButton.vue
// module id = 3069
// module chunks = 0